module.exports = __webpack_public_path__ + "img/HIDE.b8990bf1.svg";